module.exports = __webpack_public_path__ + "static/media/business_2.fe7b93bc.png";